<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable prettier/prettier -->
<template>
  <div class="payment-container">
    <div class="header">
      <h4 class="title is-5">
        {{ pi && identiyVerified 
          ? $t(`${translationPrefix}.title`, { applicantName: applicantName }) 
          : $t('helloPage.onlineCheckinPage1.title', { applicantName: applicantName }) 
        }}
      </h4>
      <language-selector></language-selector>
    </div>
    <div class="transactions-details" v-if="pi && identiyVerified">
      <h6 class="title is-6">{{ $t(`${translationPrefix}.transactionDetails`) }}</h6>

      <div v-if="booking">
        <div class="transaction-line">
          <p>{{ $t(`${translationPrefix}.bookingAmount`) }}</p>
          <p>{{ formatCurrency(booking) }}</p>
        </div>
        <hr class="rep" />
      </div>

      <div v-if="deposit">
        <!-- Option 1: Insurance fees only -->
        <div v-if="currentOption === 'insuranceFeesOption1'">
          <div class="transaction-line" v-if="deposit">
            <p>{{ $t(`${translationPrefix}.notDebitedDeposit`) }}</p>
            <p>{{ formatCurrency(deposit) }}</p>
          </div>
          <hr class="rep" v-if="deposit" />
          <div class="transaction-line" v-if="depositFees != null">
            <p>{{ $t(`${translationPrefix}.securityFees`) }}</p>
            <p>{{ formatCurrency(depositFees) }}</p>
          </div>
        </div>

        <!-- Option 2: Minimal deposit + Insurance fees -->
        <div v-if="currentOption === 'reducedDepositOption2'">
          <div class="transaction-line">
            <p>{{ $t(`${translationPrefix}.minimalDeposit`) }}</p>
            <p>{{ formatCurrency(minimalDeposit) }}</p>
          </div>
          <hr class="rep" />
          <div class="transaction-line" v-if="depositFees != null">
            <p>{{ $t(`${translationPrefix}.securityFees`) }}</p>
            <p>{{ formatCurrency(depositFees) }}</p>
          </div>
        </div>

        <!-- Option 3: Full debited deposit -->
        <div v-if="currentOption === 'standardDepositOption3'">
          <div class="transaction-line" v-if="deposit">
            <p>{{ $t(`${translationPrefix}.debitedDeposit`) }}</p>
            <p>{{ formatCurrency(deposit) }}</p>
          </div>
          <hr class="rep" v-if="deposit" />
          <div class="transaction-line">
            <p>{{ $t(`${translationPrefix}.securityFees`) }}</p>
            <p>{{ formatCurrency(0) }}</p>
          </div>
        </div>
      </div>

      <hr />
      <div class="transaction-line">
        <p><b>{{ $t(`${translationPrefix}.totalToPay`) }}</b></p>
        <p><b>{{ formatCurrency(totalAmount / 100) }}</b></p>
      </div>
    </div>
    <div class="personal-data" v-if="!pi">
      <div class="columns is-mobile">
        <b-field :label="$t('helloPage.onlineCheckinPage1.firstName')" class="column">
          <b-input v-model="firstName" type="text" :placeholder="$t('helloPage.onlineCheckinPage1.firstName')"
            class="data-input-firstname"></b-input>
        </b-field>
        <b-field :label="$t('helloPage.onlineCheckinPage1.lastName')" class="column">
          <b-input v-model="lastName" type="text" :placeholder="$t('helloPage.onlineCheckinPage1.lastName')"></b-input>
        </b-field>
      </div>
      <b-field label="Email">
        <b-input v-model="email" type="email" placeholder="nom@example.com" class="data-input"></b-input>
      </b-field>
      <b-field :label="$t('helloPage.onlineCheckinPage1.phoneNumber')">
          <phone-input v-model="phoneNumber" />
      </b-field>
      <div class="columns is-mobile" v-if="isPermalink">
        <b-field :label="$t('helloPage.onlineCheckinPage1.startDate')" class="column">
          <date-picker
            :min-date="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())"
            v-model="startDate"
            :placeholder="$t('helloPage.onlineCheckinPage1.selectDate')"
            align="left">
          </date-picker>
        </b-field>
        <b-field :label="$t('helloPage.onlineCheckinPage1.endDate')" class="column">
          <date-picker
            :min-date="startDate ? startDate : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())"
            :focused-date="startDate"
            v-model="endDate"
            :placeholder="$t('helloPage.onlineCheckinPage1.selectDate')"
            align="right">
          </date-picker>
        </b-field>
      </div>
      <div class="button-container">
        <b-button @click="requestPaymentIntent" :disabled="isButtonDisabled">{{ $t('helloPage.onlineCheckinPage1.next')
          }}</b-button>
      </div>
    </div>
    <div class="stripe-div" v-else-if="pi && identiyVerified">
      <stripe-element-payment v-on:error="onStripeError" v-on:loading="loading = !loading"
        v-on:element-change="onStripeElementChange" ref="paymentRef" :pk="pk" :elements-options="elementsOptions"
        :confirm-params="confirmParams" class="payment" />
      <b-button @click="pay" :disabled="loading || !stripeElementComplete" type="is-primary"
        :class="{ 'is-loading': loading }">
        {{ loading 
          ? $t('helloPage.onlineCheckinPage2.pleaseWait') 
          : $t(`${translationPrefix}.validate`, { total: formatCurrency(totalAmount / 100) }) 
        }}
      </b-button>
      <div class="collapses">
        <b-collapse class="card" animation="slide" v-for="(collapse, index) of collapses" :key="index"
          :open="isOpen == index" @open="isOpen = index" :aria-id="'contentIdForA11y5-' + index">
          <template #trigger="props">
            <div class="card-header" role="button" :aria-controls="'contentIdForA11y5-' + index"
              :aria-expanded="props.open">
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'chevron-down' : 'chevron-right'">
                </b-icon>
              </a>
              <p class="card-header-title">
                {{ collapse.securityFees == true 
                  ? $t(`${translationPrefix}.cardTitle`) 
                  : (collapse.commitment ? $t(`${translationPrefix}.commitmentTitle`) : $t(`${translationPrefix}.securityTitle`)) }}
              </p>
            </div>
          </template>
          <div class="card-content">
            <div class="content">
              {{ collapse.securityFees == true 
                ? $t(`${translationPrefix}.cardText`, { 
                    deposit: formatCurrencyShort(deposit), 
                    minimalDeposit: formatCurrencyShort(minimalDeposit), 
                    depositFees: formatCurrencyShort(depositFees) 
                  }) 
                : (collapse.commitment ? $t(`${translationPrefix}.commitmentText`) : $t(`${translationPrefix}.securityText`)) }}<span class="pointer" style="text-decoration: underline"
                @click="activateWithoutFees" v-if="collapse.securityFees == true">{{ $t(`${translationPrefix}.doSoHere`) }}</span>
              <br />
              <b-image v-if="collapse.displayImage" :src="require(`../assets/security.webp`)"></b-image>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
import PaymentRequestService from "@/services";
import LanguageSelector from "./atomic/LanguageSelector.vue";
import DatePicker from "./atomic/DatePicker.vue";
import PhoneInput from "./atomic/PhoneInput.vue";
export default {
  components: {
    StripeElementPayment,
    LanguageSelector,
    DatePicker,
    PhoneInput,
  },
  props: {
    paymentRequestId: String,
    withoutIdVerification: Boolean,
  },
  data() {
    return {
      idVerificationSessionId: null,
      depositWithoutFees: false,
      identiyVerified: localStorage.identityVerified,
      verifyIdentityChecked: true,
      stripeCustomerId: null,
      stripePaymentIntentId: null,
      flatId: null,
      isPermalink: null,
      startDate: null,
      endDate: null,
      pi: null,
      booking: null,
      deposit: null,
      depositFees: null,
      serviceFees: null,
      minimalDeposit: null,
      applicantName: null,
      acceptedTermsOfService: false,
      firstName: null,
      lastName: null,
      birthDate: null,
      address: null,
      phoneNumber: null,
      email: null,
      loading: false,
      stripeElementComplete: false,
      paymentRequest: null,
      pk: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      elementsOptions: {
        appearance: {}, // appearance options
      },
      confirmParams: {
        return_url: null, // success url
      },
      isOpen: 0,
      collapses: [
        {
          securityFees: true,
          commitment: false,
          bankSecurity: false,
          title: "",
          text: "",
          displayImage: false,
        },
        {
          securityFees: false,
          commitment: true,
          bankSecurity: false,
          title: "",
          text: "",
          displayImage: false,
        },
        {
          securityFees: false,
          commitment: false,
          bankSecurity: true,
          title: "",
          text: "",
          displayImage: true,
        },
      ],
    };
  },
  watch: {
    address(old, newV) {
      console.log(newV);
    },
  },
  computed: {
    isButtonDisabled() {
      return !this.firstName ||
        !this.lastName ||
        !this.email ||
        !this.phoneNumber ||
        !this.startDate ||
        !this.endDate
        ? true
        : false;
    },
    totalAmount() {
      if (this.depositWithoutFees) { //Option 3
        return Math.round(
          ((this.deposit ? this.deposit : 0) +
            (this.booking ? this.booking : 0)) *
          100
        );
      } else {
        const extra = (this.depositFees ? this.depositFees : 0) + //Option 1, frais uniquement
          (this.minimalDeposit != null && this.minimalDeposit > 0 ? this.minimalDeposit : 0); //Option 2: on ajoute le minimalDeposit au total
        return Math.round(
          ((this.booking ? this.booking : 0) + extra) * 100
        );
      }
    },
    currentOption() {
      if (!this.deposit) return 'bookingOnly';
      if (this.depositWithoutFees) return 'standardDepositOption3';
      // Option 2 is only available for deposit-only transactions
      if (this.minimalDeposit != null && this.minimalDeposit > 0 && !this.booking) {
        return 'reducedDepositOption2';
      }
      return 'insuranceFeesOption1';
    },
    translationPrefix() {
      if (this.currentOption === 'bookingOnly') {
        return 'helloPage.onlineCheckinPage2.bookingOnly';
      }
      const section = this.booking && this.deposit ? 'bookingAndDeposit' : 'depositOnly';
      return `helloPage.onlineCheckinPage2.${section}.${this.currentOption}`;
    },
  },
  created() {
    PaymentRequestService.getPaymentRequest(this.paymentRequestId)
      .then((response) => {
        this.paymentRequest = response.data;
        // If not permalink and already payed. Then directly to success page
        /*if (
          this.paymentRequest.payments.length != 0 &&
          !this.paymentRequest.isPermalink
        ) {
          this.$router.push({
            name: "success",
            query: {
              firstName: this.paymentRequest.payments[0].firstName,
              lastName: this.paymentRequest.payments[0].lastName,
              email: this.paymentRequest.payments[0].email,
              phoneNumber: this.paymentRequest.payments[0].phoneNumber,
              applicantName: this.paymentRequest.flatId,
              reservationId: this.paymentRequest.reservationId,
              startDate: this.paymentRequest.startDate,
              endDate: this.paymentRequest.endDate,
            },
          });
        }*/
        this.isPermalink = this.paymentRequest.isPermalink;
        this.flatId = this.paymentRequest.flatId;
        this.applicantName = this.paymentRequest["owner"]["commercialName"];
        this.booking = this.paymentRequest.booking;
        this.deposit = this.paymentRequest.deposit;
        this.depositFees = this.paymentRequest.depositFees;
        this.serviceFees = this.paymentRequest.serviceFees;
        this.minimalDeposit = this.paymentRequest.minimalDeposit;
        if (this.paymentRequest.type == "BOOKING_ONLY") {
          this.collapses.shift();
        }
        if (!this.paymentRequest.isPermalink) {
          this.startDate = this.paymentRequest.startDate;
          this.endDate = this.paymentRequest.endDate;
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/error";
      }).pi;
  },
  mounted() {
    // eslint-disable-next-line no-undef
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("autoc")
    );
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      this.address = place["formatted_address"];
    });
  },
  methods: {
    activateWithoutFees() {
      this.depositWithoutFees = !this.depositWithoutFees;

      this.depositFees = this.depositWithoutFees
        ? 0.0
        : this.paymentRequest.depositFees;
      this.requestPaymentIntent();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      console.log("without fees changed");
    },
    getGoogleMapsPredictions() {
      PaymentRequestService.getGoogleMapsPredictions(this.addressInput)
        .then((response) => (this.addressPredictions = response))
        .catch((error) => error);
    },
    onStripeError(error) {
      console.log(error.message);
    },
    onStripeElementChange(change) {
      this.stripeElementComplete = change.complete;
    },
    reset() {
      this.$router.push({
        name: "home",
        params: { paymentRequestId: this.paymentRequest.shortId },
      });
    },
    pay() {
      this.$refs.paymentRef.submit();
    },
    verifyIdentity() {
      PaymentRequestService.createIdVerificationSession(
        this.paymentRequest.id,
        this.firstName,
        this.lastName,
        this.phoneNumber,
        this.email
      )
        .then((response) => {
          console.log(response);
          this.idVerificationSessionId = response.data.id;
          return this.$stripe.verifyIdentity(response.data.clientSecret);
        })
        .then((result) => {
          // If `verifyIdentity` fails, display the localized
          // error message to your user using `error.message`.
          if (result.error) {
            alert(
              "Votre identité n'a pas été validée. Veuillez valider votre identité avant de continuer"
            );
            this.pi = null;
          } else {
            this.identiyVerified = true;
            localStorage.setItem("identityVerified", true);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value) + " EUR";
    },
    formatCurrencyShort(value) {
      return (
        new Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(value) + "€"
      );
    },
    requestPaymentIntent() {
      if (!this.identiyVerified && this.paymentRequest.verifyIdentity) {
        this.verifyIdentity();
      } else {
        this.identiyVerified = true;
      }
      PaymentRequestService.createPaymentIntent(
        this.firstName,
        this.lastName,
        this.email,
        this.phoneNumber,
        this.paymentRequest.id,
        this.depositWithoutFees,
        undefined,
        undefined,
        this.startDate,
        this.endDate
      )
        .then(async (response) => {
          this.pi = undefined;
          await this.$nextTick();
          this.elementsOptions.clientSecret = response.data.pi;
          this.stripeCustomerId = response.data.stripeCustomerId;
          this.stripePaymentIntentId = response.data.stripePaymentIntentId;
          console.log(
            "Payment Intent Asked",
            this.elementsOptions.clientSecret
          );
          this.pi = response.data.pi;
          this.confirmParams.return_url = encodeURI(
            process.env.VUE_APP_URL+"/success/" +
            this.paymentRequest.id +
            `?firstName=${this.firstName}&lastName=${this.lastName}&email=${this.email
            }&phoneNumber=${this.phoneNumber}&totalAmount=${this.totalAmount
            }&applicantName=${this.paymentRequest.flatId}&reservationId=${this.paymentRequest.reservationId
            }&startDate=${new Date(
              this.startDate
            ).toISOString()}&endDate=${new Date(
              this.endDate
            ).toISOString()}&isPermalink=${this.paymentRequest.isPermalink
            }&stripeCustomerId=${this.stripeCustomerId
            }&stripePaymentIntentId=${this.stripePaymentIntentId
            }&withoutFees=${this.depositWithoutFees
            }&idVerificationSessionId=${this.idVerificationSessionId}`
          );
          console.log(this.confirmParams);
          this.$el.getElementsByClassName("stripe-div").value = false;
        })
        .catch((error) => console.error(error));
    },
  },
};
</script>
<style scoped>
/* Tally-inspired styling for payment form */
.payment-container {
  max-width: 600px;
  background-color: var(--tally-white);
  border: 1px solid var(--tally-border);
  border-radius: var(--tally-radius-lg);
  padding: var(--tally-space-6);
  box-shadow: var(--tally-shadow-card);
  margin: 0 auto;
}

@media (max-width: 768px) {
  .payment-container {
    border: none;
    box-shadow: none;
  }
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: var(--tally-space-4);
  margin-bottom: 50px;
}

.header h4 {
  font-size: var(--tally-text-2xl);
  font-weight: var(--tally-font-semibold);
  color: var(--tally-text-primary);
  margin: 0;
  line-height: 1;
}

.header >>> .lang-selector {
  display: flex;
  align-items: center;
}

h6 {
  font-size: var(--tally-text-lg);
  font-weight: var(--tally-font-semibold);
  color: var(--tally-text-primary);
  margin-bottom: var(--tally-space-4);
}

.transactions-details {
  background-color: var(--tally-sidebar-hover);
  border: 1px solid var(--tally-border);
  border-radius: var(--tally-radius-md);
  padding: var(--tally-space-4);
  margin-bottom: var(--tally-space-6);
}

.transaction-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--tally-space-2) 0;
  font-size: var(--tally-text-sm);
  color: var(--tally-text-secondary);
}

.transaction-line p {
  margin: 0;
}

hr {
  border: 0;
  border-top: 1px solid var(--tally-border);
  margin: var(--tally-space-2) 0;
}

hr.rep {
  border-top: 1px solid var(--tally-border-light);
}

.personal-data {
  display: flex;
  flex-direction: column;
  gap: var(--tally-space-8);
}

/* Force all children to respect the gap and remove any default margins */
.personal-data > *,
.personal-data >>> .columns,
.personal-data >>> .columns.is-mobile {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Columns layout with consistent gap */
.personal-data >>> .columns,
.personal-data >>> .columns.is-mobile {
  display: flex;
  gap: var(--tally-space-4);
}

/* Remove Bulma's default column padding to use gap instead */
.personal-data >>> .column {
  flex: 1;
  padding: 0 !important;
}

/* Override Buefy field styling to match Tally */
.personal-data >>> .field {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}

.personal-data >>> .label {
  display: block;
  margin-bottom: var(--tally-space-2);
  font-size: var(--tally-text-sm);
  font-weight: 400;
  color: var(--tally-text-primary);
  text-transform: lowercase;
}

.personal-data >>> .input,
.personal-data >>> input:not(.vti__input) {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  font-family: var(--tally-font-family);
  font-size: 16px;
  color: var(--tally-text-primary);
  background-color: var(--tally-white);
  border: 0;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(61, 59, 53, 0.16) 0px 0px 0px 1px, rgba(61, 59, 53, 0.08) 0px 2px 5px 0px;
}

.personal-data >>> .input::placeholder,
.personal-data >>> input:not(.vti__input)::placeholder {


  text-transform: lowercase;
}

.personal-data >>> .input:hover,
.personal-data >>> input:not(.vti__input):hover {
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(61, 59, 53, 0.16) 0px 0px 0px 1px, rgba(61, 59, 53, 0.08) 0px 3px 9px 0px, rgba(61, 59, 53, 0.08) 0px 2px 5px 0px;
}

.personal-data >>> .input:focus,
.personal-data >>> input:not(.vti__input):focus {
  outline: none;
  box-shadow: rgba(58, 152, 255, 0.36) 0px 0px 0px 4px, rgba(61, 59, 53, 0.16) 0px 0px 0px 1px !important;
}

.button-container {
  margin-top: 20px !important;
}

.button-container .button,
.button-container button {
  width: 100%;
}

.personal-data >>> .button,
button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 26px 32px;
  font-family: var(--tally-font-family);
  font-size: 16px;
  font-weight: var(--tally-font-medium);
  color: var(--tally-white);
  background-color: var(--tally-primary);
  border: none;
  border-radius: var(--tally-radius-md);
  cursor: pointer;
  transition: background-color var(--tally-transition-normal);
  margin-top: 0;
}

.personal-data >>> .button:focus,
.personal-data >>> .button.is-focused,
button:focus {
  box-shadow: none !important;
  border-color: transparent !important;
}

.personal-data >>> .button:hover:not(:disabled),
button:hover:not(:disabled) {
  background-color: var(--tally-primary-hover);
}

.personal-data >>> .button:disabled,
button:disabled {
  background-color: var(--tally-primary);
  color: rgb(173, 199, 235) !important;
  opacity: 1;
  cursor: not-allowed;
}

.personal-data >>> .button.is-loading,
button.is-loading {
  position: relative;
  color: transparent;
}

.stripe-div {
  display: flex;
  flex-direction: column;
  gap: var(--tally-space-4);
}

/* Force all children to respect the gap and remove any default margins */
.stripe-div > * {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.collapses {
  margin-top: 0 !important;
  display: flex;
  flex-direction: column;
  gap: var(--tally-space-3);
}

.card {
  background-color: var(--tally-white);
  border: 1px solid var(--tally-border);
  border-radius: var(--tally-radius-md);
  overflow: hidden;
  transition: border-color var(--tally-transition-fast);
}

.card:hover {
  border-color: var(--tally-text-muted);
}

.card-header {
  display: flex;
  align-items: center;
  padding: var(--tally-space-3) var(--tally-space-4);
  background-color: var(--tally-white);
  cursor: pointer;
  user-select: none;
}

.card-header-title {
  flex: 1;
  font-size: var(--tally-text-sm);
  font-weight: var(--tally-font-medium);
  color: var(--tally-text-primary);
  margin: 0;
  padding: 0;
}

.card-header-icon {
  display: flex;
  align-items: center;
  margin-right: var(--tally-space-2);
  color: var(--tally-text-muted);
}

.card-content {
  padding: 0 var(--tally-space-4) var(--tally-space-4) var(--tally-space-4);
}

.content {
  font-size: var(--tally-text-sm);
  color: var(--tally-text-secondary);
  line-height: var(--tally-leading-relaxed);
}

.pointer {
  cursor: pointer;
  color: var(--tally-text-primary);
}

.pointer:hover {
  text-decoration: underline;
}

/* Datepicker styling */
.personal-data >>> .datepicker {
  font-family: var(--tally-font-family);
}

.personal-data >>> .datepicker .input,
.personal-data >>> .datepicker input {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  font-family: var(--tally-font-family);
  font-size: 16px;
  color: var(--tally-text-primary);
  background-color: var(--tally-white);
  border: 0;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(61, 59, 53, 0.16) 0px 0px 0px 1px, rgba(61, 59, 53, 0.08) 0px 2px 5px 0px;
}

.personal-data >>> .datepicker .input::placeholder,
.personal-data >>> .datepicker input::placeholder {
  text-transform: lowercase;
}

.personal-data >>> .datepicker .input:hover,
.personal-data >>> .datepicker input:hover {
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(61, 59, 53, 0.16) 0px 0px 0px 1px, rgba(61, 59, 53, 0.08) 0px 3px 9px 0px, rgba(61, 59, 53, 0.08) 0px 2px 5px 0px;
}

.personal-data >>> .datepicker .input:focus,
.personal-data >>> .datepicker input:focus {
  outline: none;
  box-shadow: rgba(58, 152, 255, 0.36) 0px 0px 0px 4px, rgba(61, 59, 53, 0.16) 0px 0px 0px 1px !important;
}

</style>
